.j{display:flex;}